module.exports = __webpack_public_path__ + "img/2.c0631a1d.png";